import { GRADE_TO_LABEL_MAP } from "@/search/NewSearchPageMVP/SearchResults/StandardCard/StandardCard.constants";

export const getStandardMinMaxGrade = (grades: string[] = []) => {
  if (!grades.length) return "";
  if (grades.length === 1) return GRADE_TO_LABEL_MAP[grades[0] as string];

  const minGrade = GRADE_TO_LABEL_MAP[grades[0] as string];
  const maxGrade = GRADE_TO_LABEL_MAP[grades[grades.length - 1] as string];
  if (minGrade && maxGrade) {
    return `${minGrade} - ${maxGrade}`;
  }

  return "";
};
